// extracted by css-extract-rspack-plugin
export default {"row":"cvBWVUPfay8k78lb"};